module.exports = __webpack_public_path__ + "img/HubbleDeepFieldFull_640t.656c78e1.jpg";